import * as tslib_1 from "tslib";
import { IgCollection } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { InputGroupItem as InputGroupItem_internal } from './InputGroupItem';
import { IgrInputGroupItem as IgrInputGroupItem } from './igr-input-group-item';
var IgrInputGroupInputCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrInputGroupInputCollection, _super);
    function IgrInputGroupInputCollection(list) {
        var _this = _super.call(this) || this;
        if (!IgrInputGroupItem.$type) {
            IgrInputGroupItem.$type = markType(IgrInputGroupItem, "IgrInputGroupItem");
        }
        if (list) {
            for (var i = 0; i < list.length; i++) {
                _this.add(list[i]);
            }
        }
        return _this;
    }
    IgrInputGroupInputCollection.prototype._createInnerColl = function () {
        if (!IgrInputGroupItem.$type) {
            IgrInputGroupItem.$type = markType(IgrInputGroupItem, "IgrInputGroupItem");
        }
        var coll = new SyncableObservableCollection$2(IgrInputGroupItem.$type, InputGroupItem_internal.$type, 0);
        coll.compare = function (ext, int) {
            var comp = ext;
            if (comp._implementation) {
                comp = comp._implementation;
            }
            if (comp.equals) {
                return comp.equals(int);
            }
            return comp === int;
        };
        coll.createTo = function (ext) {
            return ext._implementation;
        };
        coll.createFrom = function (int) {
            var ext = int.externalObject;
            if (!ext) {
                ext = IgrInputGroupItem._createFromInternal(int);
                if (ext) {
                    ext._implementation = int;
                }
            }
            return ext;
        };
        return coll;
    };
    return IgrInputGroupInputCollection;
}(IgCollection));
export { IgrInputGroupInputCollection };
//# sourceMappingURL=igr-input-group-input-collection.js.map
